@let ctx =
  {
    coupledConnector: (coupledConnector$ | async),
  };

<blaze-panel>
  <div icon class="icon-settings"></div>

  <div title>Setup ScriptSure</div>

  <ng-container actions>
    <blaze-environment-indicator class="mr-6" />
    <blaze-copy-connector-config-env-button
      [coupledConnector]="ctx.coupledConnector"
      (copyConfiguration)="copyConfiguration($event)"
    />
    <button
      [disabled]="connectorForm.invalid || isLoading"
      (click)="saveConnector()"
      blazeBarButton="primary"
    >
      {{ saveButtonLabel }}
    </button>
  </ng-container>

  <div content class="dialog-content">
    <form class="form" (ngSubmit)="saveConnector()" [formGroup]="connectorForm">
      <div class="form-control mb-22">
        <label class="field-label bd-field-label required">Name Your Connector</label>
        <input
          type="text"
          formControlName="connectorName"
          name="connectorName"
          class="bd-text-input tall w-full"
          required
        />
      </div>

      <div class="form-control mb-22">
        <label class="field-label bd-field-label required">Username</label>
        <input
          type="search"
          formControlName="username"
          name="username"
          class="bd-text-input tall w-full"
          required
          autocomplete="new-password"
        />
      </div>

      <div class="form-control mb-22">
        <label class="field-label bd-field-label required">Password</label>
        <input
          type="password"
          blazePasswordVisibilityToggle="bottom-0 py-0"
          formControlName="password"
          name="password"
          class="bd-text-input tall w-full"
          required
          autocomplete="new-password"
        />
      </div>

      <div class="form-control">
        <blaze-webhook-id-input [baseUrl]="webhookBaseUrl" formControlName="webhookId" />
      </div>
    </form>
  </div>
</blaze-panel>
